import RoleManagementMemberEdit from './RoleManagementMemberEdit.vue';

export default RoleManagementMemberEdit;
